import {makeAutoObservable} from 'mobx';
import axios, { AxiosResponse } from "axios";
import qs from 'qs';
import RootStore from './RootStore';
import {default as CardStore, NftType} from './CardStore';
import AccountStore from "./AccountStore";
import { NODE_URL_MAP } from 'src/constants';
import {tokenInfo, ASSET_ID} from '../constants/common';

// const MAINNET_ADDRESS = 'https://nodes.wavesnodes.com';
const MAINNET_ADDRESS = NODE_URL_MAP.W;
const MAINNET_CREATE_DAPP = '3PFQjjDMiZKQZdu5JqTHD7HwgSXyp9Rw9By';
const MAINNET_MARKET_DAPP = '3PATXDVE53rKJtkwXYV3tvuLVS2fDtGtKCc';
const MAINNET_SIGNART_DAPP = '3PDBLdsUrcsiPxNbt8g2gQVoefKgzt3kJzV';

const MAINNET_WAVESPUNKS_DAPP = '3P8rLVnwrTf4k5AB3emuduhZZb1yKcitTHy';
const MAINNET_WAVESPUNKS_ZOMBIE_DAPP = '3P7QrWH1ETLfKAJcFHYPJmQusNbDuW98Hop';
const MAINNET_WAVESPUNKS_MEMALIENS = '3PBkrb5LrGDvCwkx4VHZzZkqMNvvGqrJJWj';
const MAINNET_WAVESPUNKS_MAD = '3PJXfYMavRVzBDXqsFfwkLdEV7yuF5RToya';
const MAINNET_WAVESPUNKS_MAD2 = '3P8LcmWrr9SFrxwheZQENov5fPHEWtiwroN';
const MAINNET_WAVESPUNKS_MAD3 = '3PD5eTW5ZWzTBTph3LQmEt877DPCjQsGwwz';

const MAINNET_WAVESLANDS = '3PLncXtS1U83D6cQbFD3H8rBHPLgzxSFKZ1';
const MAINNET_WAVESDOMAINS = '3P6utP25F4wMUGG4hGdDtMXMKu2tTeNkgRs';

// waves ducks issue contracts
const MAINNET_DUCKS_INCUBATOR_DAPP = '3PEktVux2RhchSN63DsDo4b4mz4QqzKSeDv';
const MAINNET_DUCKS_BREEDER_DAPP = '3PDVuU45H7Eh5dmtNbnRNRStGwULA7NY6Hb';
const MAINNET_FARMING_DAPP = '3PAETTtuW7aSiyKtn9GuML3RgtV1xdq1mQW';

const MAINNET_SIGNARTWRAP_DAPP = '3PPgeYTWMRZ7S7jSLpnVuKKB9r6XuDk3ndC';
const MAINNET_DUCKWAPP_DAPP = '3P3pDosq4GCwfJkvq4yqKvvoTwmoqc9qPmo';

interface INftAsset {
    [key: string]: any;
    assetId: string;
    name: string;
    description: string;
    issuer: string;
    creator: string;
    quantity: number;
}
interface IAssetsNftResponse extends Array<INftAsset> {};

interface IAddressData {
    key: string;
    type: string;
    value: string|number;
}
interface IAddressDataResponse extends Array<IAddressData> {};
interface IAddressDataKeyResponse extends IAddressData {};

type AssetType = ASSET_ID.PUZZLE | ASSET_ID.USDN | ASSET_ID.EGG | ASSET_ID.WAVES;

interface IBidParams {
    key: string;
    owner: string;
    amount: number;
    assetId: AssetType;
    usdnPrice: number|string;
    usdtPrice: number|string;
}

class WalletStore {
    rootStore: RootStore;
    accountStore: AccountStore;

    items: CardStore[] = [];
    rawItems: any[] = [];

    addressNFTs: {
        address: string,
        lastUpadted: number,
        data: INftAsset[]
    }[] = [];

    searchValue: string = '';
    tmpSearchValue: string = '';

    constructor(rootStore: RootStore, accountStore: AccountStore) {
        makeAutoObservable(this, { rawItems: false });
        this.rootStore = rootStore;
        this.accountStore = accountStore;
        
        // start load
        this.updateWallet();
    }

    updateWallet(): void {
    }

    /**
     * Load all NFT from account
     */
    async loadAddressNFT(address: string, force: boolean = false): Promise<IAssetsNftResponse> {
        let allAccountNFTs: IAssetsNftResponse = [];

        if (!address) {
            return [];
        }

        let addressData = this.addressNFTs.find(item => item.address === address);
        if (!addressData || (Date.now() - addressData.lastUpadted > 120000) || force) {
            let after;
            const limit = 1000;
            while(true) {
                const res: AxiosResponse = await axios.get<IAssetsNftResponse>(`${MAINNET_ADDRESS}/assets/nft/${address}/limit/${limit}`, {
                    params: after ? {
                        after
                    } : {}
                });
                allAccountNFTs = [...allAccountNFTs, ...res.data]
                if (res.data.length === limit) {
                    after = res.data[res.data.length-1].assetId;
                } else {
                    break;
                }
            }
            const newData = {
                address,
                data: allAccountNFTs,
                lastUpadted: Date.now()
            };
            if (!addressData) {
                this.addressNFTs.push(newData);
            }

            addressData = newData;
        }

        return addressData?.data || [];
    }

    async loadNftData(nftId: string, force: boolean = false): Promise<CardStore|null> {
        if (nftId) {
            try {
                // Грузим все нфт пользователя (пока только выпущенные из нашего Дапп)
                let allUserNft: Array<INftAsset> = [];
                if (this.accountStore.address) {
                    allUserNft = await this.loadAddressNFT(this.accountStore.address, force);
                }

                // Грузим данные nft ассета
                const userNftOnSaleDetailsResponse = await axios.get<IAssetsNftResponse>(`${MAINNET_ADDRESS}/assets/details`, {
                    paramsSerializer: params => {
                        return qs.stringify(params, { arrayFormat: "repeat" })
                    },
                    params: { id: [nftId] }
                });
                let assetData = userNftOnSaleDetailsResponse.data?.[0];
                if (assetData) {
                    const wrappedOriginalIds: any = {};
                    if (assetData.issuer === MAINNET_CREATE_DAPP) {
                        const getSignArtWrapperData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_SIGNARTWRAP_DAPP}`, {
                            params: {
                                matches: `signArtNft_${assetData.assetId}_assetId`
                            }
                        });
                        getSignArtWrapperData.data.forEach((item) => {
                            wrappedOriginalIds[assetData.assetId] = item.value;
                            assetData.signArtWrapp = true;
                        });

                        const getDuckWrapperData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_DUCKWAPP_DAPP}`, {
                            params: {
                                matches: `nft_${assetData.assetId}_duckId`
                            }
                        });
                        getDuckWrapperData.data.forEach((item) => {
                            wrappedOriginalIds[assetData.assetId] = item.value;
                        });
                    }
                    // Грузим данные nft из ск для формирования структуры
                    const createDappDataResponse = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_CREATE_DAPP}`, {
                        params: { matches: `(nft_${assetData.assetId}|collection_${assetData.assetId}|group_${assetData.assetId})(.*)` }
                    });

                    // Грузим данные nft из ск маркетплейса
                    const marketDappData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_MARKET_DAPP}`, {
                        params: {
                            matches: `(nft_${assetData.assetId}${wrappedOriginalIds[assetData.assetId] ? '|nft_' + wrappedOriginalIds[assetData.assetId] : ''})(.*)`
                        }
                    });

                    createDappDataResponse?.data.forEach((item) => {
                        const [name, , key] = item.key.split('_');
                        if (name === 'nft') {
                            if (key === 'issuer') {
                                assetData.creator = item.value as string;
                            } else if (key === 'original') {
                                assetData.originalSource = item.value as string;
                            } else {
                                assetData[key] = item.value;
                            }
                        } else if (name === 'group') {
                            if (key === 'available') {
                                assetData.groupAvailable = item.value as number;
                            } else if (key === 'size') {
                                assetData.groupSize = item.value as number;
                            }
                        }
                    });

                    marketDappData?.data.forEach((item) => {
                        const [name, , key] = item.key.split('_');
                        if (name === 'nft') {
                            assetData[key] = item.value;
                        }
                    });

                    if (assetData.issuer === MAINNET_SIGNART_DAPP && assetData.description) {

                        const strParts = assetData.description.split(',');
                        if (strParts?.length) {
                            let creator;
                            let artId;
                            if (strParts[0].indexOf('Creator:') !== -1) {
                                creator = strParts[0].split(': ')[1];
                            }
                            if (strParts[1].indexOf('ArtID:') !== -1) {
                                artId = strParts[1].split(': ')[1];
                            }
                            if (creator && artId) {
                                const response = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_SIGNART_DAPP}`, {
                                    params: {
                                        matches: `(.*)_${artId}_${creator}`
                                    }
                                });
                                if (response.data) {
                                    let name: string = '';
                                    let image: string = '';
                                    let originalSource: string = '';
                                    let description: string = '';
                                    response.data.forEach((item) => {
                                        if (item.key.indexOf('art_display_cid_') !== -1) {
                                            image = item.value as string;
                                        } else if(item.key.indexOf('art_export_cid_') !== -1) {
                                            originalSource = item.value as string;
                                        } else if(item.key.indexOf('art_name_') !== -1) {
                                            name = item.value as string;
                                        } else if (item.key.indexOf('art_desc_') !== -1) {
                                            description = item.value as string
                                        }
                                    });
                                    // get likes
                                    let likes = marketDappData?.data.find((n) => {
                                        return n.key === `nft_${assetData.assetId}_likes`;
                                    })?.value || '';

                                    if (name && image) {
                                        assetData = {
                                            ...assetData,
                                            type: NftType.SIGN_ART,
                                            name,
                                            image,
                                            originalSource,
                                            creator,
                                            likes,
                                            data: "{\"collection\": \"SignArt\"}",
                                            description: description || ''
                                        };
                                    }
                                }
                            }
                        }
                    } else if (assetData.issuer === MAINNET_DUCKS_INCUBATOR_DAPP || assetData.issuer === MAINNET_DUCKS_BREEDER_DAPP) {
                        assetData = {
                            ...assetData,
                            type: NftType.DUCKS,
                            data: "{\"collection\": \"Waves Ducks\"}"
                        }
                    } else if (assetData.issuer === MAINNET_WAVESLANDS) {
                        const collection = 'WavesLands';
                        const parsed = assetData.description.split('_');
                        assetData = {
                            ...assetData,
                            type: NftType.WAVES_LANDS,
                            creator: assetData.issuer,
                            name: assetData.name,
                            image: `https://waveslands.com/api/v1/images/${parsed[2]}/png`,
                            data: JSON.stringify({collection}),
                            description: `#${parsed[0]}\nSize: ${parsed[1]}\nCode: ${parsed[2]}\nContinent: ${parsed[3]}`
                        };
                    } else if (assetData.issuer === MAINNET_WAVESDOMAINS) {
                        const collection = 'WavesDomains';
                        assetData = {
                            ...assetData,
                            type: NftType.WAVES_DOMAINS,
                            creator: assetData.issuer,
                            name: assetData.name,
                            image: `https://app.waves.domains/api/v1/nft-img/${assetData.assetId}`,
                            data: JSON.stringify({collection}),
                            description: assetData.description
                        };
                    } else if (assetData.issuer === MAINNET_CREATE_DAPP) {
                        if (wrappedOriginalIds[assetData.assetId]) {
                            assetData.likes = marketDappData?.data.find((n) => {
                                return n.key === `nft_${wrappedOriginalIds[assetData.assetId]}_likes`;
                            })?.value || '';
                            assetData.originalId = wrappedOriginalIds[assetData.assetId];
                        }
                    }

                    assetData.owner = !!allUserNft.filter(item => item.assetId === assetData.assetId).length;

                    // load duck params
                    const card = new CardStore(assetData as any, this.rootStore);
                    if (card.isDuck) {
                        const params = await this.getDuckInfo([{
                            assetId: card.originalId || assetData.assetId,
                            genotype: card.description.match(/DUCK-([A-Z]+-[A-Z]+)/)?.[1] as string
                        }])
                        card.characteristics = params[card.originalId || assetData.assetId].params;
                        card.achievements = params[card.originalId || assetData.assetId].achievements;
                    }

                    return card;
                }
            } catch (e) {
                console.error(e);
            }
        }

        return Promise.resolve(null);
    }

    async getDuckInfo(data: {genotype: string, assetId: string}[]): Promise<any> {
        if (data.length) {
            const resultData: {[x: string]: {[x: string]: any}} = {};
            const dappKeys: {[x: string]: Set<string>} = {};
            const dappValueKeys: {[x: string]: any} = {};

            let totalFarmingPower = 0;
            const getDataFarming = await axios.get<IAddressDataKeyResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_FARMING_DAPP}/total_farmingPower`);
            if (getDataFarming.data.value) {
                totalFarmingPower = parseInt(getDataFarming.data.value as string);
            }

            // collect dapp and keys
            data.forEach((item) => {
                if (!resultData[item.assetId]) {
                    resultData[item.assetId] = {genotype: item.genotype};
                }

                const generation = item.genotype[item.genotype.length - 2];

                if (generation !== 'J') {
                    const gens = item.genotype.split('-')[0];
                    const gensCount: {[x: string]: number} = {};

                    gens.split("").forEach((gen) => {
                        gensCount[gen] ? gensCount[gen]++ : gensCount[gen] = 1;
                    });
                    const genCountStr = Object.keys(gensCount).sort().reduce((prev, curr) => {
                        return prev + gensCount[curr] + curr;
                    }, '');

                    const keyTotalGens = `stats_${genCountStr}-${generation}_quantity`;
                    const keyBreedingKey = `asset_${item.assetId}_children`;
                    resultData[item.assetId].keyTotalGens = keyTotalGens;
                    resultData[item.assetId].keyBreedingKey = keyBreedingKey;

                    const dappAddr = generation === 'G' ? MAINNET_DUCKS_INCUBATOR_DAPP : MAINNET_DUCKS_BREEDER_DAPP;
                    if (!dappKeys[dappAddr]) {
                        dappKeys[dappAddr] = new Set();
                    }
                    dappKeys[dappAddr].add(keyTotalGens);

                    if (!dappKeys[MAINNET_DUCKS_BREEDER_DAPP]) {
                        dappKeys[MAINNET_DUCKS_BREEDER_DAPP] = new Set();
                    }
                    dappKeys[MAINNET_DUCKS_BREEDER_DAPP].add(keyBreedingKey);
                } else {

                }
            });

            // load data for keys
            const limit = 30;
            const dapps = Object.keys(dappKeys);
            for (let i = 0; i< dapps.length; i++) {

                let size = dappKeys[dapps[i]].size;
                let arr = Array.from(dappKeys[dapps[i]]);
                do {
                    const chunk = arr.splice(0, limit);
                    const dataDappResult = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${dapps[i]}`, {
                        paramsSerializer: params => {
                            return qs.stringify(params, { arrayFormat: "repeat" })
                        },
                        params: { key: chunk }
                    });
                    dataDappResult.data.forEach((item) => {
                        dappValueKeys[item.key] = item.value;
                    });
                    size = arr.length;
                } while(size - limit > 0);
            }

            // load achiviments
            const assetIds = Object.keys(resultData);
            const assetsSize = assetIds.length;
            do {
                try {
                    const chunk = assetIds.splice(0, limit);
                    const achievementsData = await axios.get(`https://wavesducks.com/api/v0/achievements`, {
                        params: { ids: chunk.join(',') }
                    });
                    Object.keys(achievementsData.data).forEach((key) => {
                        resultData[key].achievements = achievementsData.data[key]?.a || null;
                    });
                } catch {

                }
            } while (assetsSize - limit > 0);

            Object.keys(resultData).forEach((assetId) => {
                let totalValue = 0;
                let rarity = 0;
                let breeding = true;

                const generation = resultData[assetId].genotype[resultData[assetId].genotype.length - 2];
                if (generation !== 'J') {
                    totalValue = parseInt(dappValueKeys[resultData[assetId].keyTotalGens] as string, 10);
                    rarity = Math.pow(1 / totalValue, 0.5);
                    if (dappValueKeys[resultData[assetId].keyBreedingKey]) {
                        breeding = false
                    }
                } else {
                    totalValue = 1;
                    rarity = 1;
                    breeding = false;
                }

                let generationName = '';
                switch (generation) {
                    case 'G': generationName = 'Genesis'; break;
                    case 'H': generationName = 'Hero'; break;
                    case 'I': generationName = 'Ideal'; break;
                    case 'J': generationName = 'Jackpot'; break;
                    case 'K': generationName = 'Knight'; break;
                    case 'L': generationName = 'Lord'; break;
                    case 'M': generationName = 'Magical'; break;
                    case 'N': generationName = 'Natural'; break;
                    case 'O': generationName = 'Obstinate'; break;
                }

                resultData[assetId].params = [
                    {
                        id: 'generation',
                        title: 'Generation',
                        value: generationName
                    },
                    {
                        id: 'genotype',
                        title: 'Genotype',
                        value: resultData[assetId].genotype
                    },
                    {
                        id: 'rarity',
                        title: 'Rarity',
                        value: Math.round(rarity * 100) + '%'
                    },
                    {
                        id: 'genCount',
                        title: 'Ducks with same genes',
                        value: totalValue
                    },
                    {
                        id: 'breeding',
                        title: 'Can breed',
                        value: breeding
                    },
                    {
                        id: 'farming',
                        title: 'EGG production (per month)',
                        value: ((30 * rarity * 100 * 100)/ totalFarmingPower).toFixed(4)
                    }
                ];
            });

            return resultData;
        }

        return [];
    }

    async loadMarketNfts(assetIds: INftAsset[]): Promise<CardStore[]> {
        if (!assetIds.length) {
            return [];
        }
        try {
            const resultArr: any = {};
            const assetsIds: string[] = [];
            assetIds.forEach((item) => {
                resultArr[item.assetId] = item;
                assetsIds.push(item.assetId);
            });
            const createDappDataResponse = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_CREATE_DAPP}`, {
                params: { matches: '(nft_|collection_|group_)(.*)' }
            });

            createDappDataResponse?.data.forEach((item) => {
                const [name, assetId, key] = item.key.split('_');
                if (assetsIds.indexOf(assetId) === -1) {
                    return;
                }
                if (name === 'nft') {
                    if (resultArr[assetId]) {
                        if (key === 'issuer') {
                            resultArr[assetId].creator = item.value;
                        } else {
                            resultArr[assetId][key] = item.value;
                        }
                    }
                } else if (name === 'group') {
                    if (resultArr[assetId]) {
                        if (key === 'available') {
                            resultArr[assetId].groupAvailable = item.value as number;
                        } else if (key === 'size') {
                            resultArr[assetId].groupSize = item.value as number;
                        }
                    }
                }
            });

            return Object.keys(resultArr)
                .map(key => new CardStore(resultArr[key], this.rootStore));
        } catch(e) {
            // TODO: handle error
            console.error(e);
            return [];
        }
    }

    /**
     * Load all user NFTs in market format
     * @param userAddress 
     * @param filter 
     * @returns 
     */
    async loadUserMarketNfts(userAddress: string|null, force: boolean = false): Promise<CardStore[]> {
        if (!userAddress) return [];
        try {
            // Грузим все нфт пользователя (пока только выпущенные из нашего Дапп)
            let allUserNft = await this.loadAddressNFT(userAddress, force);

            // фильтруем нфт только нашего выпускающего ск
            allUserNft = allUserNft.filter(item => item.issuer === MAINNET_CREATE_DAPP);

            // Грузим даннные и формируем структуру для вывода на UI
            // Грузим все данные ск для формирования структуры
            const createDappDataResponse = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_CREATE_DAPP}`, {
                params: { matches: '(nft_|collection_|group_)(.*)' }
            });

            const resultArr: any = {};
            allUserNft.forEach((item) => {
                resultArr[item.assetId] = item;
            });

            createDappDataResponse?.data.forEach((item) => {
                const [name, assetId, key] = item.key.split('_');
                if (name === 'nft') {
                    if (resultArr[assetId]) {
                        if (key === 'issuer') {
                            resultArr[assetId].creator = item.value;
                        } else {
                            resultArr[assetId][key] = item.value;
                        }
                    }
                } else if (name === 'group') {
                    if (resultArr[assetId]) {
                        if (key === 'available') {
                            resultArr[assetId].groupAvailable = item.value as number;
                        } else if (key === 'size') {
                            resultArr[assetId].groupSize = item.value as number;
                        }
                    }
                }
            });

            const result = Object.keys(resultArr)
                .map(key => new CardStore(resultArr[key], this.rootStore));
            return result;
        } catch(e) {
            // TODO: handle error
            console.error(e);
            return [];
        }
    }

    async loadUserWallet(userAddress: string|null): Promise<CardStore[]> {

        if (userAddress) {

            try {
                // 1. Грузим все нфт пользователя (пока только выпущенные из нашего Дапп)
                let allUserNft = await this.loadAddressNFT(userAddress);

                // 2. Грузим те, что на продаже в маркете
                // Получаем список идентификаторов нфт, которые на продаже
                const userNftOnSaleResponse = 
                    await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_MARKET_DAPP}`, {
                        paramsSerializer: params => {
                            return qs.stringify(params)
                        },
                        params: {
                            matches: `address_${userAddress}_nft_(.*)|auction_(.*)`
                        }
                    });

                const chunks: any[] = [];
                const auctionChunks: any[] = [];
                let filtered: string[] = [];
                let auction: string[] = [];
                const chunkLimit = 30;

                // filter auctions
                userNftOnSaleResponse.data
                    .filter((item) => {
                        return typeof item.value === 'string' ? item.value.indexOf(userAddress+'_') !== -1 && item.key.indexOf('auction_') !== -1 : false;
                    })
                    .forEach((item, index, arr) => {
                        const [,assetId,] = item.key.split('_');
                        auction.push(assetId);
                        if (auction.length === chunkLimit) {
                            auctionChunks.push([...auction]);
                            auction = [];
                        }
                });
                if (auction.length) {
                    auctionChunks.push([...auction]);
                    auction = [];
                }

                // await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_MARKET_DAPP}?matches=address_%28.%2A%29_nft_%28.%2A%5B%5E_startSaleAt%5D%29%24`);
                userNftOnSaleResponse.data
                    .filter(item => item.key.indexOf(userAddress) !== -1 && item.key.indexOf('_startSaleAt') === -1)
                    .forEach((item, index, arr) => {
                        filtered.push(item.value as string);
                        if (filtered.length === chunkLimit) {
                            chunks.push([...filtered]);
                            filtered = [];
                        }
                });
                if (filtered.length) {
                    chunks.push([...filtered]);
                    filtered = [];
                }

                const userOnSaleNft: INftAsset[] = [];
                for(let i = 0; i < chunks.length; i++) {
                    // Грузим данные ассетов, которые на продаже
                    const userNftOnSaleDetailsResponse = await axios.get<IAssetsNftResponse>(`${MAINNET_ADDRESS}/assets/details`, {
                        paramsSerializer: params => {
                            return qs.stringify(params, { arrayFormat: "repeat" })
                        },
                        params: { id: chunks[i] }
                    });

                    userOnSaleNft.push(...userNftOnSaleDetailsResponse.data);
                }

                const userAuctionNft: INftAsset[] = [];
                for(let i = 0; i < auctionChunks.length; i++) {
                    // Грузим данные ассетов, которые на аукционе
                    const userNftOnSaleDetailsResponse = await axios.get<IAssetsNftResponse>(`${MAINNET_ADDRESS}/assets/details`, {
                        paramsSerializer: params => {
                            return qs.stringify(params, { arrayFormat: "repeat" })
                        },
                        params: { id: auctionChunks[i] }
                    });

                    userAuctionNft.push(...userNftOnSaleDetailsResponse.data);
                }

                // фильтруем нфт только нашего выпускающего ск
                allUserNft = allUserNft.filter(item => item.issuer === MAINNET_CREATE_DAPP);

                // 3. Грузим даннные и формируем структуру для вывода на UI
                // Грузим все данные ск для формирования структуры
                const createDappDataResponse = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_CREATE_DAPP}`, {
                    params: { matches: '(nft_|collection_|group_)(.*)' }
                });

                // Грузим данные из ск маркетплейса
                const marketDappData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_MARKET_DAPP}`, {
                    params: {
                        matches: '(nft_|auction_)(.*)'
                    }
                });

                const wrappedOriginalIds: any = {};
                const getSignArtWrapperData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_SIGNARTWRAP_DAPP}`, {
                    params: {
                        matches: '(.*)_assetId'
                    }
                });
                const ducksWrapperDappDataResult = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_DUCKWAPP_DAPP}`, {
                    params: {
                        matches: `(.*)_duckId`
                    }
                });
    
                let regex = /signArtNft_|_assetId/ig;
                getSignArtWrapperData.data.forEach((item) => {
                    wrappedOriginalIds[item.key.replaceAll(regex, "")] = item.value;
                });
    
                // get ducks original id
                regex = /nft_|_duckId/ig;
                ducksWrapperDappDataResult.data.forEach((item) => {
                    wrappedOriginalIds[item.key.replaceAll(regex, "")] = item.value;
                });

                const resultArr: any = {};

                // формируем структуру нфт на продаже
                userOnSaleNft.forEach((item) => {
                    resultArr[item.assetId] = item;
                    //set likes
                    if (wrappedOriginalIds[item.assetId]) {
                        resultArr[item.assetId].likes = marketDappData?.data.find((n) => {
                            return n.key === `nft_${wrappedOriginalIds[item.assetId]}_likes`;
                        })?.value || '';
                        resultArr[item.assetId].originalId = wrappedOriginalIds[item.assetId];
                    }
                });

                userAuctionNft.forEach((item) => {
                    resultArr[item.assetId] = item;
                    //set likes
                    if (wrappedOriginalIds[item.assetId]) {
                        resultArr[item.assetId].likes = marketDappData?.data.find((n) => {
                            return n.key === `nft_${wrappedOriginalIds[item.assetId]}_likes`;
                        })?.value || '';
                        resultArr[item.assetId].originalId = wrappedOriginalIds[item.assetId];
                    }
                    resultArr[item.assetId].isAuction = true;
                });

                marketDappData?.data.forEach((item) => {
                    const [name, assetId, key] = item.key.split('_');
                    if (name === 'nft') {
                        if (resultArr[assetId]) {
                            resultArr[assetId][key] = item.value;
                        }
                    } else if (name === 'auction') {
                        if (resultArr[assetId] && item.value) {
                            resultArr[assetId].bids = (item.value as string).split(',').map((item) => {
                                const parsed = item.split('_');
                                return {
                                    key: item,
                                    owner: parsed[0],
                                    amount: parseInt(parsed[1], 10),
                                    usdnPrice: (parseInt(parsed[1], 10) / tokenInfo[parsed[2]].decimals) * (this.rootStore.usdnPrices[parsed[2]] || 1),
                                    usdtPrice: (parseInt(parsed[1], 10) / tokenInfo[parsed[2]].decimals) * (this.rootStore.usdtPrices[parsed[2]] || 1),
                                    assetId: parsed[2]
                                };
                            }).sort((a, b) => {
                                if (a.usdtPrice > b.usdtPrice ) return 1;
                                if (a.usdtPrice < b.usdtPrice) return -1;
                                return 0;
                            });
                        }
                    }
                });

                // формируем структуру нфт на продаже
                allUserNft.forEach((item) => {
                    resultArr[item.assetId] = item;
                });

                regex = /signArtNft_|_assetId/ig;
                getSignArtWrapperData.data.forEach((item) => {
                    const assetId = item.key.replaceAll(regex, "");
                    if (resultArr[assetId]) {
                        resultArr[assetId].signArtWrapp = true;
                    }
                });

                createDappDataResponse?.data.forEach((item) => {
                    const [name, assetId, key] = item.key.split('_');
                    if (name === 'nft') {
                        if (resultArr[assetId]) {
                            if (key === 'issuer') {
                                resultArr[assetId].creator = item.value;
                            } else {
                                resultArr[assetId][key] = item.value;
                            }
                        }
                    } else if (name === 'group') {
                        if (resultArr[assetId]) {
                            if (key === 'available') {
                                resultArr[assetId].groupAvailable = item.value as number;
                            } else if (key === 'size') {
                                resultArr[assetId].groupSize = item.value as number;
                            }
                        }
                    }
                });

                const result = Object.keys(resultArr).map(key => new CardStore(resultArr[key], this.rootStore) );

                // decorate ducks
                const ducks = result.filter(item => item.isDuck);
                const genotypes: any = ducks.map((item) => {
                    return {
                        assetId: item.originalId || item.assetId,
                        genotype: item.description.match(/DUCK-([A-Z]+-[A-Z]+)/)?.[1] as string
                    }
                });

                const duckInfoResult = await this.rootStore.walletStore.getDuckInfo(genotypes);
                result.forEach((item) => {
                    if (duckInfoResult?.[item.originalId || item.assetId]) {
                        const assetId = item.originalId || item.assetId;
                        item.characteristics = duckInfoResult[assetId].params;
                        item.achievements = duckInfoResult[assetId].achievements;
                    }
                });

                // sort by date
                result.sort((a, b) => {
                    if (a.issueTimestamp < b.issueTimestamp ) return 1;
                    if (a.issueTimestamp > b.issueTimestamp) return -1;
                    return 0;
                });

                return result;

            } catch (e) {
                // TODO: handle error
                console.error(e);
            }
        }

        return [];

    }

    /**
     * Load data for Sign Art NFTs
     * @returns void
     */
    async loadUserSignArtNfts(userAddress: string | null, filter: string[] = []): Promise<CardStore[]> {
        if (!userAddress) {
            return Promise.resolve([]);
        }

        // Грузим все нфт пользователя
        let allUserNft = await this.loadAddressNFT(userAddress);

        allUserNft = allUserNft
            .filter(item => item.issuer === MAINNET_SIGNART_DAPP);

        if (filter.length) {
            allUserNft = allUserNft
                .filter(item => filter.indexOf(item.assetId) >= 0);
        }

        const resultArr: CardStore[] = [];

        const signArtNftDataResponse = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_SIGNART_DAPP}`, {
            params: {
                matches: `(art_display_cid|art_name|art_desc)_(.*)`
            }
        });

        for (let i = 0; i < allUserNft.length; i++) {
            if (allUserNft[i].description) {
                const strParts = allUserNft[i].description.split(',');
                if (strParts?.length) {
                    let creator = '';
                    let artId = '';
                    if (strParts[0].indexOf('Creator:') !== -1) {
                        creator = strParts[0].split(': ')[1];
                    }
                    if (strParts[1].indexOf('ArtID:') !== -1) {
                        artId = strParts[1].split(': ')[1];
                    }
                    if (signArtNftDataResponse.data && creator && artId) {
                        const arts: {[x: string]: {name: string; image: string; desc: string}} = {};
                        arts[artId] = {name: '', image: '', desc: ''};

                        signArtNftDataResponse.data.forEach(item => {
                            if (item.key === 'art_display_cid_' + artId + '_' + creator) {
                                arts[artId].image = item.value as string;
                            }
                            if (item.key === 'art_name_' + artId + '_' + creator) {
                                arts[artId].name = item.value as string;
                            }
                            if (item.key === 'art_desc_' + artId + '_' + creator) {
                                arts[artId].desc = item.value as string;
                            }
                        });
                        if (arts[artId].name && arts[artId].image) {
                            resultArr.push(new CardStore({
                                ...allUserNft[i],
                                type: NftType.SIGN_ART,
                                creator,
                                name: arts[artId].name,
                                image: arts[artId].image,
                                owner: userAddress,
                                data: "{\"collection\": \"SignArt\"}",
                                description: arts[artId].desc || ''
                            }, this.rootStore));
                        }
                    }
                }
            }
        }

        return resultArr;
    }

    /**
     * Load data for ducks NFTs
     * @returns void
     */
    async loadDucksNfts(userAddress: string): Promise<CardStore[]> {
        if (!userAddress) {
            return Promise.resolve([]);
        }

        // Грузим все нфт пользователя
        let allUserNft = await this.loadAddressNFT(userAddress);

        allUserNft = allUserNft
            .filter(item => item.issuer === MAINNET_DUCKS_INCUBATOR_DAPP || item.issuer === MAINNET_DUCKS_BREEDER_DAPP);

        const resultArr: CardStore[] = [];

        allUserNft.forEach((item) => {
            resultArr.push(new CardStore({
                ...item,
                owner: userAddress,
                data: "{\"collection\": \"Waves Ducks\"}",
                type: NftType.DUCKS
            }, this.rootStore));
        });

        // decorate ducks
        const genotypes: any = resultArr.map((item) => {
            return {
                assetId: item.originalId || item.assetId,
                genotype: item.description.match(/DUCK-([A-Z]+-[A-Z]+)/)?.[1] as string
            }
        });

        const duckInfoResult = await this.rootStore.walletStore.getDuckInfo(genotypes);
        resultArr.forEach((item) => {
            if (duckInfoResult?.[item.originalId || item.assetId]) {
                const assetId = item.originalId || item.assetId;
                item.characteristics = duckInfoResult[assetId].params;
                item.achievements = duckInfoResult[assetId].achievements;
            }
        });

        return resultArr;
    }

    /**
     * Load waves lands nfts
     * @returns void
     */
     async loadWavesLandsNfts(userAddress: string): Promise<CardStore[]> {
        if (!userAddress) {
            return Promise.resolve([]);
        }

        // Грузим все нфт пользователя
        let allUserNft = await this.loadAddressNFT(userAddress);

        allUserNft = allUserNft
            .filter(item => [
                MAINNET_WAVESLANDS
            ].indexOf(item.issuer) !== -1);

        const resultArr: CardStore[] = [];

        for (let i = 0; i < allUserNft.length; i++) {
            if (allUserNft[i].description) {
                const collection = 'WavesLands';
                const parsed = allUserNft[i].description.split('_');
                resultArr.push(new CardStore({
                    ...allUserNft[i],
                    type: NftType.WAVES_LANDS,
                    creator: allUserNft[i].issuer,
                    name: allUserNft[i].name,
                    image: `https://waveslands.com/api/v1/images/${parsed[2]}/png`,
                    owner: userAddress,
                    data: JSON.stringify({collection}),
                    description: `#${parsed[0]}\nSize: ${parsed[1]}\nCode: ${parsed[2]}\nContinent: ${parsed[3]}`
                }, this.rootStore));
            }
        }

        return resultArr;
    }

    /**
     * Load waves domains nfts
     * @returns void
     */
    async loadWavesDomainsNfts(userAddress: string): Promise<CardStore[]> {
        if (!userAddress) {
            return Promise.resolve([]);
        }

        // Грузим все нфт пользователя
        let allUserNft = await this.loadAddressNFT(userAddress);

        allUserNft = allUserNft
            .filter(item => [
                MAINNET_WAVESDOMAINS
            ].indexOf(item.issuer) !== -1);

        const resultArr: CardStore[] = [];

        for (let i = 0; i < allUserNft.length; i++) {
            if (allUserNft[i].description) {
                const collection = 'WavesDomains';
                resultArr.push(new CardStore({
                    ...allUserNft[i],
                    type: NftType.WAVES_DOMAINS,
                    creator: allUserNft[i].issuer,
                    name: allUserNft[i].name,
                    image: `https://app.waves.domains/api/v1/nft-img/${allUserNft[i].assetId}`,
                    owner: userAddress,
                    data: JSON.stringify({collection}),
                    description: allUserNft[i].description
                }, this.rootStore));
            }
        }

        return resultArr;
    }

    async loadAuction(nftId: string): Promise<IBidParams[]> {
        try {
            const bidsData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_MARKET_DAPP}`, {
                params: {
                    matches: `auction_${nftId}_bids`
                }
            });

            if(bidsData.data?.[0]) {
                return (bidsData.data[0].value as string).split(',').map((item) => {
                    const parsed = item.split('_');
                    return {
                        key: item,
                        owner: parsed[0],
                        amount: parseInt(parsed[1], 10),
                        usdnPrice: (parseInt(parsed[1], 10) / tokenInfo[parsed[2]].decimals) * (this.rootStore.usdnPrices[parsed[2]] || 1),
                        usdtPrice: (parseInt(parsed[1], 10) / tokenInfo[parsed[2]].decimals) * (this.rootStore.usdtPrices[parsed[2]] || 1),
                        assetId: parsed[2] as AssetType
                    };
                }).sort((a, b) => {
                    if (a.usdtPrice < b.usdtPrice ) return 1;
                    if (a.usdtPrice > b.usdtPrice) return -1;
                    return 0;
                });
            }
        } catch(e) {
            return [];
        }

        return [];
    }

    async loadCollections(collectionNames: string[] = []): Promise<{[x:string]: CardStore[]}> {
        try {
            const collectionNftData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_CREATE_DAPP}`);
            const allNfts: any = {};
            collectionNftData?.data.forEach((item) => {
                const [name, assetId, key] = item.key.split('_');
                if (name === 'nft') {
                    if (!allNfts[assetId]) {
                        allNfts[assetId] = {};
                    }
                    if (key === 'issuer') {
                        allNfts[assetId].creator = item.value;
                    } else {
                        allNfts[assetId][key] = item.value;
                    }
                } else if (name === 'group') {
                    if (!allNfts[assetId]) {
                        allNfts[assetId] = {};
                    }
                    if (key === 'available') {
                        allNfts[assetId].groupAvailable = item.value as number;
                    } else if (key === 'size') {
                        allNfts[assetId].groupSize = item.value as number;
                    } else if (key === 'sourceList') {
                        allNfts[assetId].sourceList = item.value as string;
                    }
                }
            });

            const chunks: any[] = [];
            let filtered: any[] = [];
            const chunkLimit = 40;

            Object.keys(allNfts).forEach((assetId) => {
                if (collectionNames?.length) {
                    const parsedData = JSON.parse(allNfts[assetId].data?.replaceAll('\'', '"'));
                    if (collectionNames.indexOf(parsedData.collection) >= 0) {
                        filtered.push(assetId);
                    }
                } else {
                    filtered.push(assetId);
                }
                // for partly load
                if (filtered.length === chunkLimit) {
                    chunks.push([...filtered]);
                    filtered = [];
                }
            });
            if (filtered.length) {
                chunks.push([...filtered]);
                filtered = [];
            }

            const nftCollections: {[x:string]: CardStore[]} = {};

            for(let i = 0; i < chunks.length; i++) {
                // Грузим данные nft ассета
                const collectionNFTDetails = await axios.get<IAssetsNftResponse>(`${MAINNET_ADDRESS}/assets/details`, {
                    paramsSerializer: params => {
                        return qs.stringify(params, { arrayFormat: "repeat" })
                    },
                    params: { id: chunks[i] }
                });
                
                collectionNFTDetails.data.forEach((assetData) => {
                    const nftAsset = allNfts[assetData.assetId];
                    const newItem = new CardStore({
                        ...assetData,
                        ...nftAsset
                    }, this.rootStore);
                    if (!nftCollections[newItem.collectionId]) {
                        nftCollections[newItem.collectionId] = [];
                    }
                    nftCollections[newItem.collectionId].push(newItem);
                });
            }

            return nftCollections;
        } catch(e) {
            console.error(e);
        }

        return {};
    }

    async loadCollection(collectionName: string, address: string): Promise<CardStore[]> {

        try {
            const collectionNftData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_CREATE_DAPP}`);

            const allNfts: any = {};

            collectionNftData?.data.forEach((item) => {
                const [name, assetId, key] = item.key.split('_');
                if (name === 'nft') {
                    if (!allNfts[assetId]) {
                        allNfts[assetId] = {};
                    }
                    if (key === 'issuer') {
                        allNfts[assetId].creator = item.value;
                    } else {
                        allNfts[assetId][key] = item.value;
                    }
                } else if (name === 'group') {
                    if (!allNfts[assetId]) {
                        allNfts[assetId] = {};
                    }
                    if (key === 'available') {
                        allNfts[assetId].groupAvailable = item.value as number;
                    } else if (key === 'size') {
                        allNfts[assetId].groupSize = item.value as number;
                    }
                }
            });

            const marketDappData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_MARKET_DAPP}`, {
                params: {
                    matches: '(nft_|auction_)(.*)'
                }
            });

            const wrappedOriginalIds: any = {};
            const getSignArtWrapperData = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_SIGNARTWRAP_DAPP}`, {
                params: {
                    matches: '(.*)_assetId'
                }
            });

            const ducksWrapperDappDataResult = await axios.get<IAddressDataResponse>(`${MAINNET_ADDRESS}/addresses/data/${MAINNET_DUCKWAPP_DAPP}`, {
                params: {
                    matches: `(.*)_duckId`
                }
            });

            let regex = /signArtNft_|_assetId/ig;
            getSignArtWrapperData.data.forEach((item) => {
                const assetId = item.key.replaceAll(regex, "");
                wrappedOriginalIds[assetId] = item.value;
                if (allNfts[assetId]) {
                    allNfts[assetId].signArtWrapp = true;
                }
            });

            // get ducks original id
            regex = /nft_|_duckId/ig;
            ducksWrapperDappDataResult.data.forEach((item) => {
                wrappedOriginalIds[item.key.replaceAll(regex, "")] = item.value;
            });

            marketDappData?.data.forEach((item) => {
                const [name, assetId, key] = item.key.split('_');
                if (allNfts[assetId] && name === 'nft') {
                    allNfts[assetId][key] = item.value;
                } else if (name === 'auction') {
                    if (allNfts[assetId] && item.value) {
                        allNfts[assetId].bids = (item.value as string).split(',').map((item) => {
                            const parsed = item.split('_');
                            return {
                                key: item,
                                owner: parsed[0],
                                amount: parseInt(parsed[1], 10),
                                usdnPrice: (parseInt(parsed[1], 10) / tokenInfo[parsed[2]].decimals) * (this.rootStore.usdnPrices[parsed[2]] || 1),
                                usdtPrice: (parseInt(parsed[1], 10) / tokenInfo[parsed[2]].decimals) * (this.rootStore.usdtPrices[parsed[2]] || 1),
                                assetId: parsed[2]
                            };
                        }).sort((a, b) => {
                            if (a.usdtPrice > b.usdtPrice ) return 1;
                            if (a.usdtPrice < b.usdtPrice) return -1;
                            return 0;
                        });
                    }
                }
            });

            const chunks: any[] = [];
            let filtered: any[] = [];
            const chunkLimit = 30;

            Object.keys(allNfts).forEach((assetId) => {
                const parsedData = JSON.parse(allNfts[assetId].data?.replaceAll('\'', '"'));
                if (parsedData.collection?.indexOf(address + '_'+ collectionName) !== -1) {
                    filtered.push(assetId);
                }
                // for partly load
                if (filtered.length === chunkLimit) {
                    chunks.push([...filtered]);
                    filtered = [];
                }
            });
            if (filtered.length) {
                chunks.push([...filtered]);
                filtered = [];
            }

            const nftCollection: CardStore[] = [];

            for(let i = 0; i < chunks.length; i++) {
                // Грузим данные nft ассета
                const collectionNFTDetails = await axios.get<IAssetsNftResponse>(`${MAINNET_ADDRESS}/assets/details`, {
                    paramsSerializer: params => {
                        return qs.stringify(params, { arrayFormat: "repeat" })
                    },
                    params: { id: chunks[i] }
                });
                
                collectionNFTDetails.data.forEach((assetData) => {
                    //set likes
                    if (wrappedOriginalIds[assetData.assetId]) {
                        assetData.likes = marketDappData?.data.find((n) => {
                            return n.key === `nft_${wrappedOriginalIds[assetData.assetId]}_likes`;
                        })?.value || '';
                        assetData.originalId = wrappedOriginalIds[assetData.assetId];
                    }
                    nftCollection.push(new CardStore({
                        ...assetData,
                        ...allNfts[assetData.assetId]
                    }, this.rootStore));
                });
            }

            // decorate ducks
            const ducks = nftCollection.filter(item => item.isDuck);
            const genotypes: any = ducks.map((item) => {
                return {
                    assetId: item.originalId || item.assetId,
                    genotype: item.description.match(/DUCK-([A-Z]+-[A-Z]+)/)?.[1] as string
                }
            });

            const duckInfoResult = await this.rootStore.walletStore.getDuckInfo(genotypes);
            nftCollection.forEach((item) => {
                if (duckInfoResult?.[item.originalId || item.assetId]) {
                    const assetId = item.originalId || item.assetId;
                    item.characteristics = duckInfoResult[assetId].params;
                    item.achievements = duckInfoResult[assetId].achievements;
                }
            });

            // sort by date
            nftCollection.sort((a, b) => {
                if (a.issueTimestamp < b.issueTimestamp ) return 1;
                if (a.issueTimestamp > b.issueTimestamp) return -1;
                return 0;
            });

            return nftCollection;
        } catch(e) {
            console.error(e);
        }

        return Promise.resolve([]);
    }
}

export default WalletStore;